import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { v as valueRegex } from '../utils.esm.js';
import { TabsContext } from '../TabsContext/index.esm.js';
import './styles.css';


var styles = {
    "panel": "TabsPanel-module_panel__RINio",
    "panel_active": "TabsPanel-module_panel_active__Q0Y0V"
};

const TabsPanel = /*#__PURE__*/ forwardRef(({ // id,
className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, value, children }, ref)=>{
    const { activeTab, baseId } = useContext(TabsContext);
    const panelClassName = `${styles.panel} ${activeTab === value ? styles.panel_active : ''}`.trim();
    if (!valueRegex.test(value)) {
        throw new Error('Value kan kun inneholde tegn som er gyldig i en html id.');
    }
    return /*#__PURE__*/ jsx("div", {
        ref: ref,
        id: `ds-tab-panel-${baseId}-${value}`,
        className: `${panelClassName} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        role: 'tabpanel',
        "aria-labelledby": `ds-tab-id-${baseId}-${value}`,
        hidden: activeTab !== value,
        children: children
    });
});
TabsPanel.displayName = 'TabsPanel';

export { TabsPanel };
